import { AllocationMethodEnum } from '@/constant';
import { memo } from 'react';

import { HeaderCreate } from '..';
import { ApplicantList, AssignmentInfo } from './components';
import { useLogic } from './define-assignment.logic';

const DefineAssignmentView = () => {
	const {
		formik,
		fetchData,
		onSave,
		params,
		rowSelection,
		applicantRowSelection,
		dateSourceAutomatic,
		fetchingAutomatic,
		_searchParams,

		programCommonList,
		programList,
	} = useLogic();

	return (
		<div>
			<HeaderCreate
				title="일반(농가) 배정 등록"
				onClickCreate={onSave}
				titleSave="저장"
			/>

			<div className="bg-white">
				<AssignmentInfo
					{...{
						formik,
						fetchData,
						params,
						rowSelection,
						applicantPublicMainFranchiseId: _searchParams.publicFranchiseId,
						programCommonList,
						programList,
					}}
				/>
			</div>
			{formik.values.assignmentMethod !==
				AllocationMethodEnum.NO_ASSIGNMENT && (
				<ApplicantList
					formik={formik}
					fetchData={fetchData}
					rowSelection={rowSelection}
					applicantRowSelection={applicantRowSelection}
					dateSourceAutomatic={dateSourceAutomatic}
					fetchingAutomatic={fetchingAutomatic}
				/>
			)}
		</div>
	);
};

export default memo(DefineAssignmentView);
